<template>
  <b-modal v-model="show" ref="modal">
    <template #modal-title>
      <h3 class="font-weight-bold">Select Template</h3>
    </template>

    <div v-if="isLoadingTemplates" class="text-center py-5">
      <digger-loader />
    </div>

    <b-card
      v-else
      v-for="template in templates"
      :key="template.id"
      @click="onSelectTemplate(template)"
      class="mb-1 p-1 px-4 c-pointer btnTemplate"
      no-body
    >
      <div class="d-flex align-items-center flex-nowrap template-row">
        <section class="mr-2 template-icon">
          <img width="40" :src="template.icon && template.icon.url" />
        </section>
        <section class="template-label">{{ template.label }}</section>
      </div>
    </b-card>

    <template #modal-footer>
      <b-button variant="secondary" @click="$refs.modal.hide()">
        Cancel
      </b-button>
    </template>

    <div style="height: 16px"></div>
  </b-modal>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'SelectTemplateModal',

  props: {
    showModal: { default: false },
  },

  data() {
    return {
      isLoadingTemplates: true,
    }
  },

  computed: {
    ...mapGetters('template', ['templates']),

    show: {
      get() {
        return this.showModal
      },
      set() {
        this.$emit('closeModal')
        this.isLoadingTemplates = false
      },
    },
  },

  watch: {
    showModal(shown) {
      if (shown) this.fetchTemplates()
    },
  },

  methods: {
    ...mapActions('template', {
      getTemplates: 'getTemplates',
    }),

    async fetchTemplates() {
      this.isLoadingTemplates = true

      await this.getTemplates()
        .catch((err) => this.handleError(err))
        .finally(() => (this.isLoadingTemplates = false))
    },

    onSelectTemplate(template) {
      this.$emit('selected', template)
      this.$refs.modal.hide()
    },
  },
}
</script>

<style lang="scss" scoped>
.btnTemplate {
  font-size: 16px;
}

.btnTemplate:hover {
  background-color: #eaf3ff;
}

.template-icon {
  flex: 0 0 auto;
}

/* Label keeps its place beside the icon and can shrink instead of dropping
 * onto its own line below the icon. */
.template-label {
  flex: 1 1 auto;
  min-width: 0;
  line-height: 1.2;
}

/* Smallest phones: trim the card padding, icon and font so long labels like
 * "Verification of Competency" stay on one line next to their icon. */
@media (max-width: 400px) {
  .btnTemplate {
    font-size: 14px;
    padding-left: 0.75rem !important;
    padding-right: 0.75rem !important;
  }

  .template-icon img {
    width: 32px;
  }
}
</style>
